var FINANCIAL_NUMBER_MAXLENGTH = 26;
function financialAccountFormatter(newValue, oldValue) {
	var financialAccount = '';
	if (newValue && oldValue) {
		if (newValue.length == 8 && oldValue.length == 7) {
			financialAccount = newValue + '-';
		} else if (newValue.length == 18 && oldValue.length == 17) {
			var last = newValue.slice(newValue.length - 1);
			financialAccount = newValue.slice(0, -1) + '-' + last;
		} else if (newValue.length == 18 && oldValue.length == 19 || newValue.length == 8 && oldValue.length == 9) {
			financialAccount = newValue.slice(0, -1);
		} else { // ha nem kell a kötőjel, atól még a modellt át kell adni
			financialAccount = newValue;
		}
	} else if (newValue) { // ha az első karaktert írja be, nincs oldValue még
		financialAccount = newValue;
	} else {
		if (newValue == '') { // ha kitöröl mindent, a newValue üres string, ami false-ra értékelődik ki
			financialAccount = newValue;
		}
	}
	if (newValue && newValue.length > FINANCIAL_NUMBER_MAXLENGTH) {
		financialAccount = oldValue;
	}
	return financialAccount;
}

export default financialAccountFormatter;
